module.exports = __webpack_public_path__ + "static/default-3d47f703d11ac1878ddfac078164c89c.jpg";